export default function interRef(context, content, key) {
  const { compose } = context;
  const { $ } = content;
  const { href } = $;
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      key={key}
    >
      {content._ || compose(context, content.$$)}
    </a>
  );
}
